import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge } from "react-bootstrap";
import { getFormattedDate } from "../../../utils/method";
import { isSystemRole } from "../../../utils/isSystemRole";

const getRoleTableColumns = (t) => [
	{
		field: "provided",
		headerName: t("roles.provided"),
		headerTooltip: t("roles.provided"),
		unSortIcon: true,
		valueFormatter: (params) => getFormattedDate(params.data.createdAt),
		maxWidth: 160,
		minWidth: 160,
	},
	{
		field: "name",
		headerName: t("roles.title"),
		headerTooltip: t("roles.title"),
		unSortIcon: true,
		flex: 1,
		cellRenderer: (params) => {
			const roleKey = params.data?.name;
			const label = roleKey
				? t(`roles.types.${roleKey}`, { defaultValue: roleKey })
				: "";
			return (
				<span className="d-inline-flex align-items-center gap-2">
					<span>{label}</span>
					{isSystemRole(params.data) && (
						<Badge bg="secondary" className="roles-grid__system-badge">
							<FontAwesomeIcon icon={faLock} className="me-1" fixedWidth />
							{t("roles.system-role")}
						</Badge>
					)}
				</span>
			);
		},
	},
];

export { getRoleTableColumns };
